import { isDRMEnabled } from '@jwplayer/companion/drm';
import { queryCache } from 'react-query';

import { useQuery } from '/module/query';

const getQueryKey = (siteId: string) => ['site-drm-enabled', siteId];

export async function hydrateQueryCache(siteId: string) {
  await queryCache.prefetchQuery(getQueryKey(siteId), ({ signal }) => retrieve(siteId, signal));
}

const retrieve = async (siteId: string, signal?: AbortController['signal']) =>
  (
    await isDRMEnabled({
      siteId,
      signal,
    })
  ).content.is_enabled;

export function useSiteDrmEnabled(siteId: string) {
  const { data, isLoading, refetch } = useQuery(getQueryKey(siteId), ({ signal }) => retrieve(siteId, signal), {
    refetchOnMount: false,
    refetchOnReconnect: false,
    refetchOnWindowFocus: false,
    forceFetchOnMount: false,
    // Prevent background refetches by setting staleTime to infinity
    staleTime: Number.POSITIVE_INFINITY,
    retry: false,
  });

  return {
    isDrmEnabledOnSite: Boolean(data),
    isLoading,
    refetch,
  };
}
